import {useEffect} from "react";
import FullPageLoadingIndicator from "../components/FullPageLoadingIndicator";
import {removeStudentLocalStorage} from "../components/Providers/JWTProvider";

const SignOut = () => {
    useEffect(() => {
        removeStudentLocalStorage();
        window.location.href = "/";
    }, []);

    return <FullPageLoadingIndicator />;
};

export default SignOut;
